import { API_URL } from '@webapp/common/conf';

import {
    createPopupId,
    createSurveyUrl,
    div,
    frame,
    isMobile,
    onLoad,
    popupPrefix,
    reopenKey as reopenKeyRaw,
    request
} from './common';
import { createShowNeverButton, Popup } from './html-popup';

import './widget.css';

// eslint-disable-next-line import/no-unresolved
import badge from '!!raw-loader!@webapp/ui/lib/icons/badge.svg?raw';

const url = `${API_URL}/core/v1/get/widget`;

// TODO merge with popup, use class hierarchy

const ADDITIONAL_PADDING_FOR_FIX_SCROLL = 10;

window.ttgrafSetWidgetParams = ({ id }): void =>
    request(url, { survey: id }, (xhr) => {
        const reopenKey = `${reopenKeyRaw}-${id}`;
        const response = JSON.parse(xhr.response);
        const params = JSON.parse(response.params);

        if (isMobile && !params.mobileDisplay) {
            return null;
        }

        const {
            activeInvite,
            button1Text,
            button2Text,
            buttonColor,
            buttonTextColor,
            cancelReinvite,
            elementColor,
            inviteTimer
        } = params;

        const iframe = frame(id as number);
        iframe.src = createSurveyUrl(response.rewrite, 'widget', true);
        const widget: HTMLDivElement = document.createElement('div');

        const autoHeight = params.opened_auto_height;
        let width = `${params.opened_width}vw`;
        let height = `${params.opened_height}vh`;
        let openedPosition = params.opened_position || 'center';

        if (isMobile) {
            openedPosition = 'center';
            width = '95%';

            if (params.mobileDisplay === 1) {
                height = '95%';
            } else if (params.mobileDisplay === 2) {
                height = '50%';
            }
        }

        const mainPopup = new Popup({
            id: `${popupPrefix}${id}`,
            close: true,
            content: iframe,
            elementColor,
            width: `max(${width}, 320px)`,
            height: autoHeight ? '200px' : `max(${height}, 200px)`,
            position: openedPosition,
            borderRadius: `${params.opened_radius}px`,
            hideContainer: autoHeight
        });

        let popupOpened = false;
        let openByTimer = false;

        mainPopup.onOpen(() => {
            popupOpened = true;

            widget.classList.add('ttgraf-widget-trigger_hidden');
        });

        const startTimer = (): void => {
            setTimeout(() => {
                if (!mainPopup.isOpened() && !popupOpened) {
                    mainPopup.open();
                    openByTimer = true;
                }
            }, parseInt(inviteTimer, 10) * 1000 || 10000);
        };

        if (activeInvite) {
            const openMainPopup = (): void => {
                const cancelReopen = localStorage.getItem(reopenKey);
                if (!cancelReopen) {
                    onLoad(startTimer);
                }
            };

            let cancelReopenPopup = null;

            if (cancelReinvite) {
                const showLaterButton = document.createElement('button');
                showLaterButton.classList.add(`${popupPrefix}reopen__button`);
                showLaterButton.innerText = button1Text;
                showLaterButton.style.background = buttonColor;

                if (buttonTextColor === 'dark') {
                    showLaterButton.style.color = '#000';
                }

                const popupShowNeverButton = createShowNeverButton(button2Text, buttonColor, buttonTextColor);

                showLaterButton.addEventListener('click', () => {
                    localStorage.removeItem(reopenKey);
                    cancelReopenPopup.close();
                });

                popupShowNeverButton.addEventListener('click', () => {
                    localStorage.setItem(reopenKey, 'true');
                    cancelReopenPopup.close();
                });

                const actions = div();
                actions.classList.add(`${popupPrefix}actions`);
                actions.appendChild(showLaterButton);
                actions.appendChild(popupShowNeverButton);

                cancelReopenPopup = new Popup({
                    id: createPopupId(id as number),
                    close: false,
                    className: `${popupPrefix}reopen`,
                    content: actions,
                    elementColor,
                    position: openedPosition
                });
            }

            mainPopup.onClose(() => {
                if (cancelReopenPopup && openByTimer && !localStorage.getItem(reopenKey)) {
                    cancelReopenPopup.open();
                }

                widget.classList.remove('ttgraf-widget-trigger_hidden');
            });

            openMainPopup();
        } else {
            mainPopup.onClose(() => {
                widget.classList.remove('ttgraf-widget-trigger_hidden');
            });
        }

        widget.classList.add('ttgraf-widget-trigger');

        if (!params.position) {
            params.position = 'RIGHT_MIDDLE';
        }

        if (params.widgetType === 2) {
            widget.classList.add(`ttgraf-widget-trigger-text-logo--${params.position.toLowerCase()}`);

            widget.style.color = params.textColor === 'dark' ? '#000' : '#FFF';
            widget.style.width = `${params.width}px`;
            widget.style.height = `${params.height}px`;
            widget.style.border = `1px solid ${params.borderColor}`;
            widget.style.borderRadius = `${params.radius}px`;

            if (params.widgetColor && (params.widgetColor2 || params.widgetColor3)) {
                widget.style.background = `linear-gradient(90deg, ${params.widgetColor} 0%, ${params.widgetColor2} 50%, ${params.widgetColor3} 100%)`;
            } else {
                widget.style.backgroundColor = `${params.widgetColor}`;
            }

            const marginRight = params.position?.indexOf('RIGHT') === 0 ? params.width / 2 - params.height / 2 : 0;
            const marginLeft = params.position?.indexOf('LEFT') === 0 ? params.width / 2 - params.height / 2 : 0;

            if (marginRight) {
                widget.style.marginRight = `-${marginRight}px`;
            }

            if (marginLeft) {
                widget.style.marginLeft = `-${marginLeft}px`;
            }

            if (params.logo) {
                widget.classList.add('ttgraf-widget-trigger-text-logo');

                widget.innerHTML = `
                    <span></span>
                    <img
                        class='ttgraf-widget-trigger__logo'
                        src='${`${API_URL_ENV}${params.logo}`}'
                        alt='logo'
                    />
                    <span class='ttgraf-widget-trigger-text-logo__divider' style='background-color: ${
                        params.borderColor
                    }'></span>
                    <span class='ttgraf-widget-trigger__text'>
                        ${params.feedback}
                    </span>
                    <span></span>
                `;
            } else {
                widget.innerHTML = `
                    <span class='ttgraf-widget-trigger__text'>${params.feedback}</span>
                `;
            }
        } else {
            widget.classList.add(`ttgraf-widget-trigger--${params.position.toLowerCase()}`);
            widget.style.color = buttonColor;
            widget.innerHTML = badge;
        }

        widget.addEventListener('click', () => {
            mainPopup.open();
            openByTimer = false;
        });

        document.body.appendChild(widget);

        window.addEventListener('message', ({ data }) => {
            if (data === 'scrollTop') {
                setTimeout(() => mainPopup.scrollTop(), 100);
            }

            if (data === 'finish' || data === 'disqual') {
                localStorage.setItem(reopenKey, 'true');
            }
            const PREFIX = `[WidgetHeight-${id}]:`;
            if (typeof data === 'string' && data.slice(0, PREFIX.length) === PREFIX && autoHeight) {
                const height = data.replace(PREFIX, '');
                console.log('OUTSIDE: update height -> ', height);
                mainPopup.setHeight(`${parseFloat(height) + ADDITIONAL_PADDING_FOR_FIX_SCROLL}px`);
                mainPopup.showContainer();
            }
        });
    });
